webpackJsonp([71883469174636],{

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/virtualclimber.1bc08464.jpg";

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _publication = __webpack_require__(27);
	
	var _publication2 = _interopRequireDefault(_publication);
	
	var _videoframe = __webpack_require__(28);
	
	var _videoframe2 = _interopRequireDefault(_videoframe);
	
	var _extLink = __webpack_require__(24);
	
	var _extLink2 = _interopRequireDefault(_extLink);
	
	var _virtualclimber = __webpack_require__(118);
	
	var _virtualclimber2 = _interopRequireDefault(_virtualclimber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paperURL = "http://www.jst.go.jp/erato/igarashi/projects/climber/climber.pdf";
	
	var abstractBibTexStr = "@inproceedings{Pfeil:2011:ICR:2077378.2077381,\n  author = {Pfeil, Jonas and Mitani, Jun and Igarashi, Takeo},\n  title = {Interactive Climbing Route Design Using a Simulated Virtual Climber},\n  booktitle = {SIGGRAPH Asia 2011 Sketches},\n  series = {SA '11},\n  year = {2011},\n  isbn = {978-1-4503-1138-0},\n  location = {Hong Kong, China},\n  pages = {2:1--2:2},\n  articleno = {2},\n  numpages = {2},\n  url = {http://doi.acm.org/10.1145/2077378.2077381},\n  doi = {10.1145/2077378.2077381},\n  acmid = {2077381},\n  publisher = {ACM},\n  address = {New York, NY, USA},\n}";
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Interactive Climbing Route Design Using a Simulated Virtual Climber"
	      ),
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "We propose a climbing route designer that aims to enable even novice climbers to create interesting and challenging routes by designing them on the computer using a simulated climber to analyze the route and visualize the result."
	      })
	    ),
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Virtual Climber"
	    ),
	    _react2.default.createElement(_videoframe2.default, {
	      youtubeId: "xmCBqyCxcIw",
	      img: _virtualclimber2.default,
	      imgAltText: "Interactive Climbing Route Design Using a Simulated Virtual Climber: Simulated climber next to two real climbers"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "description" },
	      _react2.default.createElement(
	        "p",
	        null,
	        "This was my project while working as a Visiting Researcher at the",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "http://www.jst.go.jp/erato/igarashi/en/" },
	          "JST ERATO Igarashi Design Interface Project"
	        ),
	        ", Tokyo, Japan."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Additional video:",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "https://www.youtube.com/watch?v=Vjp_0aDZwX8" },
	          "Creation of a climbing route by a study participant"
	        )
	      ),
	      _react2.default.createElement(_publication2.default, {
	        type: "Short Paper",
	        title: "Interactive Climbing Route Design Using a Simulated Virtual Climber",
	        bookTitle: "SIGGRAPH Asia 2011 Sketches",
	        authors: "Jonas Pfeil, Jun Mitani and Takeo Igarashi",
	        bibTex: abstractBibTexStr,
	        paperURL: paperURL,
	        paperLinkText: "Paper"
	      }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Abstract"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Route setting is the process of creating climbing routes for the sport of free climbing. By fastening climbing holds to artificial climbing walls, a route emerges that provides a challenge for climbers. It is a difficult process usually requiring either a very skilled climber or a lot of time and test climbs. We propose a climbing route designer that aims to enable even novice climbers to create interesting and challenging routes by designing them on the computer using a simulated climber to analyze the route and visualize the result."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "While the user places climbing holds on the wall, the software tries to find a route from the start configuration of the virtual climber to a finish hold. Each hand or foot is moved individually and the static poses are tested for feasibility and scored for difficulty. The progress of the search is visualized to give the user immediate feedback. When finished, the climber is animated and the resulting route is shown, including the difficulty of the individual poses. In our current implementation static poses are calculated by a heuristic, not using physics based calculation. Dynamics are not considered and movement between the poses is simply interpolated. Using this prototype of the virtual climber it was possible to successfully test the user interface concept and collect a lot of feedback and ideas. We conducted an informal user study with climbers that had varying degrees of route setting experience."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The climbing route designer allows fast exploration of possible climbing routes by testing variants easily. According to study participants it could be especially useful for beginners or experienced route setters creating climbing routes for children, as well as getting inspiration. One user stated that if the virtual climber climbed better, it could remove the need to test climb every route. According to the users many of the static poses resemble real life climbing poses, but a lot are still unrealistic. The results from our informal user study can be a starting point for implementations using more complex algorithms to generate climber poses and animation."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "facts" },
	      _react2.default.createElement(
	        "dl",
	        null,
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Software"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "C++, SNOPT, Qt, OpenSceneGraph"
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "People"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Jonas Pfeil"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Jun Mitani"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          _react2.default.createElement(
	            _extLink2.default,
	            { to: "http://www.s.u-tokyo.ac.jp/en/people/igarashi_takeo/" },
	            "Prof. Takeo Igarashi"
	          )
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Year"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "2011"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-virtualclimber-jsx-37256935e913dab35a26.js